import type { SessionSubtype } from '@/lib/schemas/db'

const OPTIONS: Array<{
  value: SessionSubtype
  label: string
  activeClass: string
}> = [
  {
    value: 'TeamViewer Session',
    label: 'TeamViewer',
    activeClass: 'bg-blue-600',
  },
  {
    value: 'Sit-down Session',
    label: 'Sit-down',
    activeClass: 'bg-emerald-600',
  },
]

/** Session-only: which kind of session this is. */
export function SessionSubtypeSection(props: {
  sessionSubtype?: SessionSubtype
  onChangeSessionSubtype?: (subtype: SessionSubtype) => void | Promise<void>
}) {
  const { sessionSubtype, onChangeSessionSubtype } = props
  const selected = sessionSubtype ?? 'TeamViewer Session'

  return (
    <section className="rounded-md border border-slate-200 bg-white p-4">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
        Session type
      </h3>
      <p className="mt-1 text-[11px] text-slate-500">
        TeamViewer: “Remote support session” • Sit-down: “In-person at
        office/customer”
      </p>
      <div className="mt-3 inline-grid w-fit grid-cols-2 rounded-full border border-slate-300 bg-white p-1">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={
              selected === option.value
                ? `cursor-pointer rounded-full ${option.activeClass} px-4 py-2 text-xs font-semibold text-white`
                : 'cursor-pointer rounded-full px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-100'
            }
            onClick={() => onChangeSessionSubtype?.(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </section>
  )
}
